import { render, staticRenderFns } from "./ProgramSocDetail.vue?vue&type=template&id=1617f23d"
import script from "./ProgramSocDetail.vue?vue&type=script&lang=js"
export * from "./ProgramSocDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports